import { H3 } from "@sellar-io/components";
import React, { ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { AlertContainer } from "../alert/AlertContainer";
import { AlertType } from "../alert/AlertType";

const getMessageStyles = (type: AlertType): string => {
  switch (type) {
    case "information":
      return "text-blue-800";
    case "success":
      return "text-emerald-800";
    case "warning":
      return "text-orange-800";
    case "error":
      return "text-red-800";
    default:
      return "";
  }
};

const PromptRoot = ({
  children,
  className,
  type,
}: {
  children: ReactNode;
  className?: string;
  type: AlertType;
}) => {
  return (
    <AlertContainer type={type} className={className}>
      {children}
    </AlertContainer>
  );
};

const Header = ({
  type,
  children,
}: {
  type: AlertType;
  children: ReactNode;
}) => {
  return <H3 className={getMessageStyles(type)}>{children}</H3>;
};

const Content = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => {
  return (
    <div className={twMerge("flex flex-col gap-2", className)}>{children}</div>
  );
};

export {
  PromptRoot as Prompt,
  Header as PromptHeader,
  Content as PromptContent,
};
